import { Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { ModalStyles } from './Styles';

type NoBiometryModalProps = {
  show?: boolean;
  onChangeShow(show: boolean): void;
};

export const NoBiometryModal = ({
  show,
  onChangeShow,
}: NoBiometryModalProps) => {
  const { t } = useTranslation();
  return (
    <ModalStyles
      show={show}
      onChangeShow={onChangeShow}
      header={{ title: t('Select a biometric') as string }}
      footer={{
        onSubmitButton: () => onChangeShow(false),
        onCloseButton: () => onChangeShow(false),
        closeButtonLabel: t('Cancel') as string,
        submitButtonLabel: t('Accept') as string,
      }}
      hasPadding
      disableOnClickOutside
    >
      <Label>{t('You must activate at least one biometric to continue')}</Label>
    </ModalStyles>
  );
};
